import { SnapshotModel } from '..';
import { Collections } from '../../constants';
import { ERate } from '../../types/rates';

export class RateModel extends SnapshotModel<ERate, typeof Collections.rates> {
  get type() {
    return Collections.rates;
  }
}
